import React, { useEffect, useState } from 'react';

import { Col, Row, Form, Table } from 'react-bootstrap';

import { Link } from 'react-router-dom';

import './styles.css';

import Menu from '../../components/Menu';

import search from '../../assets/images/search.png';
import editar from '../../assets/images/edit.png';
import excluir from '../../assets/images/delete.png';
import api from '../../services/api';
import CustomModal from '../../components/CustomModal';
import { useAlert } from 'react-alert';

const Admin = () => {
  const [admins, setAdmins] = useState([]);
  const [searchString, setSearchString] = useState('');
  const [show, setShow] = useState(false);
  const [idDelete, setIdDelete] = useState(null);

  const alert = useAlert();

  const getAdmins = async (search = '') => {
    try {
      const { data: { resources }
      } = await api.get('admin/admin', { params: { search } });
      setAdmins(resources.data);
    } catch (error) {
      console.log(error.response);
    }
  }


  useEffect(() => {
    getAdmins();
  }, []);
  const handleDelete = async id => {
    setShow(true);
    setIdDelete(id);
  }
  const finishDelete = async () => {
    try {
      const { data: { resources }
      } = await api.delete(`admin/admin/${idDelete}`);
      alert.show("Dados removidos com sucesso!");
      setAdmins(resources.data);
    } catch (error) {
      console.log(error);
    }
    setShow(false);
  }
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchString(value);
    getAdmins(value);
  }
  const handleShow = () => setShow(false);

  return (
    <div className="container-fluid">
      <CustomModal show={show} handleShow={handleShow} onDelete={finishDelete} />
      <Menu />
      <div className="content">
        <Row>
          <Col sm={12} className="col-title">
            <div className="titlePages">
              <h5>Usuários</h5>
              <Link to="/admin/novo">
                <button className="btnYellow">NOVO</button>
              </Link>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <Form className="formSearch">
              <Form.Group controlId="formBasicEmail">
                <Form.Control type="text" placeholder="Buscar" name="search" value={searchString} onChange={handleSearch} />
                <button><img src={search} alt="Icon" /></button>
              </Form.Group>
            </Form>
          </Col>
        </Row>
        <Row>
          <Col sm={10}>
            <Table responsive>
              <thead>
                <tr>
                  <th className="tableLeft">Nome</th>
                  <th className="tableLeft">E-mail</th>
                  <th>Editar</th>
                  <th>Excluir</th>
                </tr>
              </thead>
              <tbody>
                {admins.map((admin, key) => (
                  <tr key={key}>
                    <td className="tableLeft">{admin.name}</td>
                    <td className="tableLeft">{admin.email}</td>
                    <td>
                      <Link to={`/admin/edit/${admin.id}`}>
                        <img className="imgEdit" src={editar} alt="Icon" />
                      </Link>
                    </td>
                    <td><img className="imgDelete" src={excluir} alt="Icon" onClick={() => handleDelete(admin.id)} /></td>
                  </tr>

                ))}

              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Admin;